import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { ProjectStatusBadge } from './ProjectStatusBadge';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';

export const ProjectTitle = () => {
  const { id } = useParams();
  const { data: currentProject, isLoading: isProjectFetching } = useGetProjectByIdQuery({
    id: id,
  });
  const name = currentProject ? currentProject.name : '';

  return (
    <LoaderWrapper
      loader={
        <div className="flex justify-between w-full items-end">
          <Skeleton className="h-6 w-1/3" />
        </div>
      }
      isLoading={isProjectFetching}
    >
      <div className="flex items-center gap-3 truncate">
        <p title={name} className="font-bold font-jamjuree text-lg text-ebony opacity-80 truncate">
          {name}
        </p>
        <ProjectStatusBadge />
      </div>
    </LoaderWrapper>
  );
};
